import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { shareIcons } from '../../shared/styles/icons';
import { shareLinks } from '../../shared/constants';
import { styles } from './styles/VideoShareStyles';
import Viewports from '../../../assets/components/fsUtils/Viewports';
import TrackingUtils from '../../../assets/components/fsUtils/TrackingUtils';
import Analytics from '../../../assets/components/analytics/Analytics';

class VideoShare extends React.Component {
	constructor(props){
        super(props);

        this.state = {
            url: this.props.videoUrl,
            videoUrl: encodeURIComponent(this.props.videoUrl), 
            title: this.props.title
        }

        this.utmParam = "utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit";
        this.viewport = new Viewports();
        this.pageMeta = Analytics.getPageMeta();
        this.pageType = this.pageMeta ? this.pageMeta.page_type : 'post';
        
        this.handleCopyToClipboard = (e) => {
            let target = e.target.parentElement;
            let textArea = document.getElementById('cpyLink');
            textArea.select();
            try {
                document.execCommand('copy');
            } catch(e) {
                console.log('Oops, unable to copy', e.message);
            }

            target.setAttribute('data-social-tooltip', 'Copied to clipboard');

            this.trackShareLink(e);
        }

        this.isMobile = this.viewport.isTouch || this.viewport.winW < 1024;
        this.isAndroid = this.viewport.isAndroid;

        this.trackShareLink = this.trackShareLink.bind(this);
        
    }

    onMouseLeave(e){
        var target = e.target.parentElement;
        target.removeAttribute('data-social-tooltip');
    }

    trackShareLink(e) {

        let utmSource = e.target.parentElement.getAttribute('data-share-type');
        let utmTerm = this.pageType;
        if (typeof window.utag !== "undefined") {

            if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
                var utmObj = {
                    'utm_campaign' : 'share_buttons',
                    'utm_medium' : 'fscom',
                    'utm_source' : 'share-' + utmSource,
                    'utm_term': utmTerm,
                    'utm_content' : 'original_share'
                  };
          
                  var trackObj = {
                      'url': TrackingUtils.addTrackingQuery(utmObj, this.state.url),
                      js: 1 // flag indicating that this is a dynamic event, keep it "1"
                  };
          
                  PARSELY.beacon.trackPageView(trackObj);
            }
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(){

    }
    

	render() {        
        let url = this.props.videoUrl;
        let videoUrl = encodeURIComponent(this.props.videoUrl);
        let title =  this.props.title;
        const utmParam = this.utmParam + '&utm_term=' + this.pageType;
        const smsShare = videoUrl + '?' + encodeURIComponent( utmParam + '&utm_source=share_sms');
        let shareStyles = [shareIcons.icMarginLeft, shareIcons.icShareDefault];

        this.shareLinks = {
            fb: shareLinks.FB_SHARE +  videoUrl + '?' + utmParam + '&utm_source=share_fb',
            tw: shareLinks.TWITTER_SHARE +  videoUrl + '?' + utmParam + '&utm_source=share_tw&&via=FoxSports&text=' + title,
            em: shareLinks.MAIL + encodeURIComponent('Read more @FOXSports - ' + title) + '&body=Read more @FOXSports - ' + title + ' - ' +  videoUrl + '?' + encodeURIComponent( utmParam + '&utm_source=share_em'),
            whatsapp: 'whatsapp://send?text=' + videoUrl + '?' +  encodeURIComponent( utmParam + '&utm_source=share_whatsapp'),
            sms: this.isAndroid ? 'sms:?body=' + encodeURIComponent( smsShare ) :  'sms:&body=' +  smsShare,
            cpyLink: url + '?' + utmParam + '&utm_source=share_url'
        }
		return (
            <div className={css(shareIcons.inlineContainer)}>
                <input id="cpyLink" value={this.shareLinks.cpyLink} className={css(styles.hidden)}/>
                <a href={this.shareLinks.fb} data-share-type={"fb"}
                    target="_blank" className={css(shareIcons.icShareDefault)} onClick={this.trackShareLink}> <span className={css(shareIcons.icFacebook)}></span> </a>
                { this.isMobile && <a href={this.shareLinks.whatsapp} data-share-type={"whatsapp"} className={css(shareStyles)} onClick={this.trackShareLink}> <span className={css(shareIcons.icWhatsappShare)}></span> </a> }
                { this.isMobile && <a href={this.shareLinks.sms} data-share-type={"sms"} className={css(shareStyles)} onClick={this.trackShareLink}> <span className={css(shareIcons.icSmsShare)}></span> </a> }
                {/* <a href={this.shareLinks.tw} target="_blank" className={css(shareIcons.icShare)}>
                     <span className={css([shareIcons.icTwitterShare, shareIcons.icShare ])}></span> </a> */}
                 { !this.isMobile && <button data-share-type={"url"} className={css(shareStyles, shareIcons.icShareBtn)} onClick={this.handleCopyToClipboard} onMouseLeave={this.onMouseLeave}> <span className={css(shareIcons.icUrlShare)}> </span> </button> }
                 { !this.isMobile && <a href={this.shareLinks.em} data-share-type={"email"} className={css(shareStyles)} onClick={this.trackShareLink}> <span className={css(shareIcons.icEmailShare)} ></span> </a> }
                
            </div>
		);
	}

}

export default VideoShare;



// WEBPACK FOOTER //
// ./react-app-src/videoPlayer/components/VideoShare.js